export default "__VITE_ASSET__CIcQKerm__"